
// import React, { useEffect, useState } from "react";
// import { MapContainer, TileLayer, useMap, Circle } from "react-leaflet";
// import L from "leaflet";
// import "leaflet.heat";
// import { collection, getDocs } from "firebase/firestore";
// import { db } from "../firebase";

// const HeatmapLayer = ({ points }) => {
//   const map = useMap();
//   const [zoomLevel, setZoomLevel] = useState(map.getZoom());

//   useEffect(() => {
//     if (!map || points.length === 0) return;

//     console.log("[HeatmapLayer] Rendering heatmap with points:", points);

//     const heat = L.heatLayer(points, {
//       radius: 50,
//       blur: 50,
//       maxZoom: 10,
//       minOpacity: 0.4,
//       gradient: {
//         0.1: "green",
//         0.4: "yellow",
//         0.7: "orange",
//         1.0: "red"
//       }
//     }).addTo(map);

//     const onZoom = () => {
//       const currentZoom = map.getZoom();
//       console.log("[HeatmapLayer] Zoom level changed:", currentZoom);
//       setZoomLevel(currentZoom);
//     };

//     map.on("zoomend", onZoom);

//     return () => {
//       map.removeLayer(heat);
//       map.off("zoomend", onZoom);
//     };
//   }, [map, points]);

//   return (
//     <>
//       {zoomLevel >= 12 &&
//         points.map((pos, idx) => (
//           <Circle key={idx} center={pos} radius={10} color="red" />
//         ))}
//     </>
//   );
// };

// const HeatMapView = () => {
//   const [heatPoints, setHeatPoints] = useState([]);
//   const [mapCenter, setMapCenter] = useState([20.5937, 78.9629]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         console.log("[HeatMapView] Fetching data from Firestore...");

//         const snapshot = await getDocs(collection(db, "live_location"));
//         console.log("[HeatMapView] Raw Firestore snapshot:", snapshot);

//         const points = snapshot.docs
//   .map((doc, index) => {
//     const data = doc.data();
//     console.log(`[HeatMapView] Document ${index} data:`, data);

//     const geoPoint = data?.polyline_array?.[0];
//     if (geoPoint && typeof geoPoint.latitude === "number" && typeof geoPoint.longitude === "number") {
//       return [geoPoint.latitude, geoPoint.longitude];
//     }

//     console.warn("[HeatMapView] Skipping invalid coordinate:", geoPoint);
//     return null;
//   })
//   .filter(coord => coord !== null);

//         console.log("[HeatMapView] Final extracted heat points:", points);
//         setHeatPoints(points);

//         if (points.length > 0) {
//           const avgLat = points.reduce((acc, point) => acc + point[0], 0) / points.length;
//           const avgLng = points.reduce((acc, point) => acc + point[1], 0) / points.length;
//           console.log("[HeatMapView] Calculated map center:", [avgLat, avgLng]);
//           setMapCenter([avgLat, avgLng]);
//         } else {
//           console.warn("[HeatMapView] No valid heat points found.");
//         }
//       } catch (error) {
//         console.error("[HeatMapView] Error fetching data from Firestore:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   return (
//     <MapContainer center={mapCenter} zoom={7} style={{ height: "100vh", width: "100%" }}>
//       {/* <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" /> */}
//       <TileLayer
//   url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
//   attribution='&copy; <a href="https://carto.com/">CARTO</a> contributors'
// />
//       <HeatmapLayer points={heatPoints} />
//     </MapContainer>
//   );
// };

// export default HeatMapView;

import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, useMap, Circle } from "react-leaflet";
import L from "leaflet";
import "leaflet.heat";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

const HeatmapLayer = ({ points }) => {
  const map = useMap();
  const [zoomLevel, setZoomLevel] = useState(map.getZoom());

  useEffect(() => {
    if (!map || points.length === 0) return;

    const heat = L.heatLayer(points, {
      radius: 50,
      blur: 50,
      maxZoom: 10,
      minOpacity: 0.4,
      gradient: {
        0.1: "green",
        0.4: "yellow",
        0.7: "orange",
        1.0: "red"
      }
    }).addTo(map);

    const onZoom = () => setZoomLevel(map.getZoom());
    map.on("zoomend", onZoom);

    return () => {
      map.removeLayer(heat);
      map.off("zoomend", onZoom);
    };
  }, [map, points]);

  return (
    <>
      {zoomLevel >= 12 &&
        points.map((pos, idx) => (
          <Circle key={idx} center={pos} radius={10} color="red" />
        ))}
    </>
  );
};

const HeatMapView = () => {
  const [heatPoints, setHeatPoints] = useState([]);
  const [mapCenter, setMapCenter] = useState([20.5937, 78.9629]);
  const [isDarkMode, setIsDarkMode] = useState(false);

  const lightTile = "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png";
  const darkTile = "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const snapshot = await getDocs(collection(db, "live_location"));
        const points = snapshot.docs
          .map(doc => {
            const geoPoint = doc.data()?.polyline_array?.[0];
            if (geoPoint && typeof geoPoint.latitude === "number" && typeof geoPoint.longitude === "number") {
              return [geoPoint.latitude, geoPoint.longitude];
            }
            return null;
          })
          .filter(Boolean);

        setHeatPoints(points);

        if (points.length > 0) {
          const avgLat = points.reduce((acc, p) => acc + p[0], 0) / points.length;
          const avgLng = points.reduce((acc, p) => acc + p[1], 0) / points.length;
          setMapCenter([avgLat, avgLng]);
        }
      } catch (error) {
        console.error("[HeatMapView] Error ", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <MapContainer center={mapCenter} zoom={7} style={{ height: "100vh", width: "100%" }}>
        <TileLayer
          url={isDarkMode ? darkTile : lightTile}
          attribution='&copy; <a href="https://carto.com/">CARTO</a> contributors'
        />
        <HeatmapLayer points={heatPoints} />
      </MapContainer>

      {/* Toggle button */}
      <button
  onClick={() => setIsDarkMode(!isDarkMode)}
  style={{
    position: "absolute",
    top: "10px",
    right: "10px",
    zIndex: 1000,
    padding: "10px 16px",
    backgroundColor: isDarkMode ? "#1e1e1e" : "#f0f0f0",
    color: isDarkMode ? "#f0f0f0" : "#1e1e1e",
    border: "none",
    borderRadius: "8px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
    transition: "all 0.3s ease"
  }}
>
  {isDarkMode ? "☀ Light Mode" : "🌙 Dark Mode"}
</button>

    </div>
  );
};

export default HeatMapView;
